import { render, staticRenderFns } from "./customers-component.vue?vue&type=template&id=2b6afd3c&lang=html&"
import script from "./customers-component.vue?vue&type=script&lang=js&"
export * from "./customers-component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports